var exports = {
  "k": "xaee3c4fa--81766f--checkbox",
};

module.exports = exports;
